// Simplest way to check if array
export default async (value) => Array.isArray(value)
